<div class="container">
    <div style="text-align: center;">
        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" *ngIf="usuario==null"></span>
    </div>
    

    <div class="card shadow-lg border-0 rounded-lg mt-5" *ngIf="usuario!=null">
        <div class="card-header" style="color: teal;">
            <h3 class="text-center font-weight-light my-4">{{usuario.data().nombre}}</h3>
        </div>
        <div class="card-body">
            

            <ul class="list-group">
                <li class="list-group-item" *ngIf="procesodeEliminarActivo">
                    <ngb-alert type="danger">
                        <strong>¿Eliminar locación?</strong>
                        <p><small>Esta locación se eliminará del aplicativo</small></p>
                    </ngb-alert>
                    <p>
                        <ngb-alert [type]="tipodeAlerta" (close)="closeAlert()">{{ mensajeAlerta }} <span *ngIf="trabajando" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span></ngb-alert>
                    </p>
                    <div>
                        <button class="btn btn-primary" (click)="cancelarEliminar()" style="float: left; margin-left: 4px;">Cancelar</button>
                        <button class="btn btn-danger" (click)="eliminarCuenta(usuario.id)" style="float: right; margin-right: 4px;">Eliminar</button>
                    </div>
                </li>
                <li class="list-group-item" *ngIf="!procesodeEliminarActivo">
                    <button class="btn btn-danger btn-block"  (click)="confirmaEliminar()">Eliminar</button>
                </li>
            </ul>
            <hr>
                    <!-- <div class="row" style="background-color: rgba#9b9a9a;" >
                        <p>1. Seleccione una regional / cuenca: - </p>
                        <div class="form-group">
                            <select class="form-control" id="exampleFormControlSelect1" [(ngModel)]="regional" (change)="validaboton()" >
                            <option>Putumayo Norte</option>
                            <option>Putumayo Sur</option>
                            <option>VMM</option>
                            <option>VMM-otros</option>
                            <option>Administración Bog.</option>
                            </select>
                        </div>
                    </div> -->

           
           
        </div>
        <div class="card-footer text-center">
           <button class="btn btn-primary  btn-block" (click)="cerrar(null)">Cerrar</button>
        </div>
    </div>
</div>